import instance from "@/services/api";

export const checkListsAPI = {
  async getCheckListsList(params) {
    return await instance()
      .get("/common/check_lists/read/", { params })
      .then((res) => res?.data);
  },
  
  async updateCheckList(data) {
    return await instance()
      .post("/common/check_lists/modify/", data)
      .then((res) => res?.data);
  },
  
  async deleteCheckList(checkListId) {
    return await instance()
      .delete(`/common/check_lists/delete/${checkListId}/`)
      .then((res) => res?.data);
  },
};
